export default __webpack_public_path__ + "static/LP-OCampaign-Hero-11126e362067695a64cac73e8bf25b92.mp4";